<template>
  <!-- <div class="flex vx-col">
        <div class="flex flex-col p-5 rounded-lg justify-center border border-dashed bg-grey-100 cursor-pointer">
            <div class="w-full flex  justify-center py-3">
                <feather-icon icon="UploadCloudIcon" class="inline-block mr-2" svgClasses="w-16 h-16 text-primary" />
            </div>
            <div class="flex flex-col items-center justify-center">
                <div class="text-primary">Upload File</div>
            </div>
        </div>
    </div> -->
  <vs-button class="mb-5" icon="icon-upload" :type="type" icon-pack="feather">{{
    label
  }}</vs-button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "Tambah File",
    },
    type: {
      type: String,
      default: 'filled'
    }
  },
};
</script>